import { msgTypes } from "constants/msgTypes";
import { Validation } from "constants/Validation";
import * as Yup from "yup";

export const BlogSchema = Yup.object({
    blogId: Yup.string(),
    title: Yup.string().required(Validation.required.message.replaceAll("^","Blog title"))
                    .matches(Validation.plaintext.regex , Validation.plaintext.message),
    // metaTitle: Yup.string()
    //                 .matches(Validation.plaintext.regex , Validation.plaintext.message),
    // shortDescription: Yup.string()
    //                 .matches(Validation.plaintext.regex , Validation.plaintext.message),
    // description: Yup.string().required(Validation.required.message.replaceAll("^","Blog description"))
    //                 .matches(Validation.plaintext.regex , Validation.plaintext.message),
    // metaDescription: Yup.string().matches(Validation.plaintext.regex , Validation.plaintext.message),
    // altTag: Yup.string().matches(Validation.plaintext.regex , Validation.plaintext.message),
    image: Yup.string().required(Validation.required.message.replaceAll("^","Image")),
    imageFile: Yup.mixed().nullable()
    .test(
        "FILE_FORMAT",
        msgTypes.IMAGE_UNSUPPORTED_FORMAT,
        (value) => !value || (value && [msgTypes.IMAGE_FORMAT.JPEG,
            msgTypes.IMAGE_FORMAT.JPG, msgTypes.IMAGE_FORMAT.PNG, msgTypes.IMAGE_FORMAT.WEBP, msgTypes.IMAGE_FORMAT.SVG
        ].includes(value?.type))
    )
    .test(
        "FILE_SIZE",
        msgTypes.FILE_SIZE_MESSAGE_1MB,
        (value) =>!value || (value && value.size <=msgTypes.FILE_SIZE_1MB)
    )
})
